import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, UserCircle } from "lucide-react";
import { getRoleFromToken } from "../../api";
import { ROLES_ESTOQUE } from "../../constants/estoque";
import { ROLES_RH } from "../../constants/rh";
import { ROLES_GESTAO_REALIZADO } from "../../constants/gestaoRealizado";
import {
  isTemaNatalAtivo,
  EstilosNatal,
  NeveNatal,
  PiscaPisca,
  HeroNatal,
  PresenteNatalModal,
} from "../../components/natal/TemaNatal";
import DEPARTAMENTOS_GESTAO_ORCAMENTARIA, { ROLES_DESPESAS_GERAIS, ROLES_GESTAO_ORCAMENTARIA } from "../../constants/departamentosOrcamento"
const roleLabels = {
  admin: "Administrador",
  financeiro: "Financeiro",
  rh: "Recursos Humanos",
  diretor: "Diretoria",
  administracao: "Administração",
  usuario: "Usuário Comum",
  viagens: "Viagem",
  onlyFormulario: "DM",
};

const rolesAtuais = [
  "admin",
  "RH",
  "TI",
  "ADMFIN",
  "NEGOCIOS",
  "EXECUTIVA",
  "VIAGENS",
  "FACILITIES",
  "COMERCIAL",
  "QUALIDADE",
  "JURIDICO",
  "OPERACAO",
  "MARKETING",
  "GESTOR_ESTRATEGICO",
  "PESSOA&CULTURA",
  "VIAGEMCOMERCIAL",
  "VIAGEMFACILITIES"
];

const rolesCoordenadores = rolesAtuais.map((role) => `COORDENADOR_${role}`);
// Adicionamos as roles base + as roles com o prefixo COORDENADOR_
const todasRolesPermitidas = [
  ...rolesAtuais,
  ...rolesCoordenadores,
  "financeiro",
  "diretor",
  "administracao",
];

const modules = [
  {
    path: "/margem-bruta",

    title: " Monitoramento de Custos e Margem Bruta",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 3h6l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V3zm6 0v5h5M9 13h6M9 17h6M9 9h1"
        />
      </svg>
    ),
    tag: "Dash-Boards",
    description:
      "Acompanhamento da execução operacional com foco em custos, projetos e performance versus planejamento.",
    highlights: ["Realizado", "Previsto", "Margem", "Total Geral"],
    allowedRoles: [
      "admin",
      "financeiro",
      "diretor",
      "OPERACAO",
      "ASSISTENTEOPERACAO",
      "GESTOR_ESTRATEGICO",
    ],
  },
  // {
  //   path: "/margem-bruta",
  //   title: "Margem Bruta",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="w-7 h-7"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={1.8}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
  //       />
  //     </svg>
  //   ),
  //   tag: "Resultado",
  //   description: "Visão consolidada da Margem Bruta por projeto.",
  //   highlights: ["Faturamento", "Custo MOB", "Margem %"],
  //   allowedRoles: [
  //     "admin",
  //     "financeiro",
  //     "diretor",
  //     "administracao",
  //     "OPERACAO",
  //     "ASSISTENTEOPERACAO",
  //   ],
  // },
  // {
  //   path: "/margem-bruta-percentual",
  //   title: "Margem Bruta %",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="w-7 h-7"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={1.8}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
  //       />
  //     </svg>
  //   ),
  //   tag: "Resultado",
  //   description: "Visão consolidada da Margem Bruta por projeto.",
  //   highlights: ["Margem %"],
  //   allowedRoles: ["admin", "HELIO"],
  // },
  {
    path: "/orcamento-dash",
    title: "Orçamento YOUX",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    ),
    tag: "Planejamento",
    description:
      "Acompanhamento do orçamento por departamento, com despesas categorizadas para análise clara de desvios.",
    highlights: ["Por Departamento", "Por Categoria", "Previsto vs Real"],
    allowedRoles: todasRolesPermitidas,
  },
  {
    path: "/gestao-orcamentaria/boas-vindas",
    title: "Gestão Orçamentária",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 2v20M5 6h11a3 3 0 010 6H8a3 3 0 000 6h11"
        />
      </svg>
    ),
    tag: "Planejamento Anual",
    description:
      "Planejamento orçamentário anual com reajuste, inflação e expansão de licenças, projetado mês a mês.",
      

    highlights: ["Despesas Gerais", "Reajuste/Inflação", "Projeção Mensal"],
    allowedRoles: ROLES_GESTAO_ORCAMENTARIA,
  },
  // onlyFormulario (Formulário GP) só acessa a Alocação de Pessoal dentro da Gestão Orçamentária
  // — entra direto nela, sem passar pelo Boas-vindas do módulo.
  {
    path: "/gestao-orcamentaria/alocacao-pessoal",
    title: "Gestão Orçamentária",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 2v20M5 6h11a3 3 0 010 6H8a3 3 0 000 6h11"
        />
      </svg>
    ),
    tag: "Planejamento Anual",
    description:
      "Alocação mensal (%) dos colaboradores da Operação nos projetos.",
    highlights: ["Alocação de Pessoal"],
    allowedRoles: ["onlyFormulario"],
  },
  {
    path: "/gestao-realizado/visao-geral",
    title: "Gestão do Realizado",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4M3 3v18h18M7 16V9m5 7v-3m5 3V7"
        />
      </svg>
    ),
    tag: "Realizado",
    description:
      "Realizado com a mesma granularidade do orçado: faturamento por competência, saldo a faturar e notas fiscais.",
    highlights: ["Faturamento", "Controle de Competência", "Orçado x Realizado"],
    allowedRoles: ROLES_GESTAO_REALIZADO,
  },
  // {
  //   path: "/custos-por-projeto",
  //   title: "Detalhamento de Custos",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="w-7 h-7"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={1.8}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M4 6h16M4 10h16M4 14h16M4 18h16"
  //       />
  //     </svg>
  //   ),
  //   tag: "Lançamentos",
  //   description:
  //     "Listagem completa de todos os lançamentos de custo por projeto, permitindo drill-down analítico em cada movimentação financeira registrada.",
  //   highlights: ["Todos Lançamentos", "Filtros Avançados", "Por Projeto"],
  //   allowedRoles: [
  //     "admin",
  //     "rh",
  //     "financeiro",
  //     "diretor",
  //     "administracao",
  //     "OPERACAO",
  //     "ASSISTENTEOPERACAO",
  //   ],
  // },
  // {
  //   path: "/simulacao-folha",
  //   title: "Simulador de Folha",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="w-7 h-7"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={1.8}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 11h.01M12 11h.01M15 11h.01M4 19h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2z"
  //       />
  //     </svg>
  //   ),
  //   tag: "Simulação",
  //   description:
  //     "Ferramenta de simulação financeira para modelar cenários de reajuste salarial, novas contratações e desligamentos, projetando o impacto na folha de pagamento.",
  //   highlights: ["Reajuste Salarial", "Contratações", "Desligamentos"],
  //   allowedRoles: ["admin", "rh", "financeiro", "diretor", "OPERACAO"],
  // },
  // {
  //   path: '/salarios-por-projeto',
  //   title: 'Detalhamento Salarial',
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
  //       <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
  //     </svg>
  //   ),
  //   tag: 'RH & Custos',
  //   description:
  //     'Visibilidade completa da remuneração dos colaboradores segmentada por departamento e projeto, auxiliando na análise de custo de pessoal.',
  //   highlights: ['Por Colaborador', 'Por Departamento', 'Custo Total'],
  //   allowedRoles: ['admin' , 'rh' , 'financeiro', 'diretor']
  // },
  {
    path: "/dash/visao-geral",
    title: "Painel Executivo",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
        />
      </svg>
    ),
    tag: "Dash-Boards",
    description:
      " Central de inteligência financeira para tomada de decisão. Consulte dados de fluxo de caixa, indicadores de inadimplência, análise de competência e históricos de releases da empresa.",
    highlights: ["Por Empresa", "Saldos Iniciais e Finais", "Geração de Caixa"],
    allowedRoles: ["admin", "financeiro", "diretor","GESTOR_ESTRATEGICO","COORDENADOR_RH"],
  },

  {
    path: "/painel-faturamento",
    title: "Gestão Financeira de Projetos",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 3h6l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V3zm6 0v5h5M9 13h6M9 17h6M9 9h1"
        />
      </svg>
    ),
    tag: "Faturamento",
    description:
      "Módulo de apoio ao GP para acompanhamento do ciclo financeiro dos projetos. Visão consolidada para tomadas de decisão rápidas: acompanhe o faturamento atual, posições de competência, inadimplência e solicite novas NFs diretamente no portal.",
    highlights: ["Emissão de notas fiscais"],
    allowedRoles: [
      "admin",
      "financeiro",
      "diretor",
      "GP",
      "OPERACAO",
      "GESTOR_ESTRATEGICO",
      "ASSISTENTEOPERACAO",
      "OPERACAO"
    ],
  },

  //   {
  //   path: "/colaboradores",
  //   title: "Simulador de Orçamento por Departamento",
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       className="w-7 h-7"
  //       fill="none"
  //       viewBox="0 0 24 24"
  //       stroke="currentColor"
  //       strokeWidth={1.8}
  //     >
  //       <path
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         d="M7 3h6l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V3zm6 0v5h5M9 13h6M9 17h6M9 9h1"
  //       />
  //     </svg>
  //   ),
  //   tag: "Faturamento",
  //   description:
  //     "Módulo de apoio à gestão operacional, consolidando reajuste salárial, auxiliando na tomada de decisão.",
  //   highlights: ["Simulador salarial por departamento"],
  //   allowedRoles: [
  //     "admin",
  //     "RH",
  //     "TI",
  //     "ADMFIN",
  //     "NEGOCIOS",
  //     "EXECUTIVA",
  //     "COMERCIAL",
  //     "QUALIDADE",
  //     "JURIDICO",
  //     "OPERACAO",
  //     "MARKETING",
  //     "GESTOR_ESTRATEGICO",
  //     "PESSOA&CULTURA",
  //   ],
  // },
  {
    path: "/painel-formulario",
    title: "Formulário Financeiro (GP)",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 3h6l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V3zm6 0v5h5M9 13h6M9 17h6M9 9h1"
        />
      </svg>
    ),
    tag: "Faturamento",
    description:
      "Formulário para solicitação de emissão de notas fiscais junto ao financeiro.",
    highlights: ["Emissão de notas fiscais"],
    allowedRoles: ["onlyFormulario"],
  },

  {
    path: "/rh",
    title: "Pessoas & Cultura",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H2v-2a4 4 0 015-3.87m6-4.13a4 4 0 11-8 0 4 4 0 018 0zm6 2a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
    ),
    tag: "RH",
    description:
      "Cadastro de colaboradores e vínculos (CLT, PJ, estágio), contratos PJ com aditivos no Google Docs e desligamentos.",
    highlights: ["Colaboradores", "Contratos PJ", "Aditivos", "Desligamentos"],
    allowedRoles: ROLES_RH,
  },

  {
    path: "/estoque",
    title: "Gestão de Estoque",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
        />
      </svg>
    ),
    tag: "Facilities",
    description:
      "Controle dos materiais de cozinha e limpeza da sede: vistoria, notas fiscais, saídas e saldo em unidades e R$.",
    highlights: ["Cadastros", "Vistoria", "Entradas por NF", "Saldo do período"],
    allowedRoles: ROLES_ESTOQUE,
  },

  {
    path: "/central-ajuda",
    title: "Central de Ajuda",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-7 h-7"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.09 9a3 3 0 015.83 1c0 2-3 2-3 4M12 17h.01M12 21a9 9 0 100-18 9 9 0 000 18z"
        />
      </svg>
    ),
    tag: "Ajuda",
    description:
      "Documentação de uso dos módulos, além de um canal para enviar sugestões de melhoria e reportar bugs.",
    highlights: ["Documentação", "Sugestões", "Reporte de bugs"],
  },
];

const adminModules = [
  {
    path: "/admin",
    title: "Administração",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    tag: "Admin",
    description: "Painéis e ferramentas restritos a administradores: usuários, contratos OMIE, sugestões/bugs e mapeamento de dados.",
    highlights: ["Painel Administrativo", "Contratos OMIE", "Sugestões e Bugs", "Origem dos Dados"],
  },
];

const tagColors = {
  Resultado: "bg-emerald-100 text-emerald-700",
  Planejamento: "bg-blue-100 text-blue-700",
  Lançamentos: "bg-amber-100 text-amber-700",
  Simulação: "bg-violet-100 text-violet-700",
  "RH & Custos": "bg-rose-100 text-rose-700",
  "Dash-Boards": "bg-emerald-100 text-emerald-700",
  Faturamento: "bg-purple-100 text-black-700",
  DRE: "bg-indigo-100 text-indigo-700",
  Admin: "bg-red-100 text-red-700",
  Ajuda: "bg-teal-100 text-teal-700",
  Facilities: "bg-orange-100 text-orange-700",
};

export default function Welcome() {
  const navigate = useNavigate();
  const userRole = getRoleFromToken();

  const availableModules = modules.filter(
    (mod) => !mod.allowedRoles || mod.allowedRoles.includes(userRole),
  );

  const isAdmin = userRole === "admin";
  const natal = isTemaNatalAtivo();
  const [presenteAberto, setPresenteAberto] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {natal && (
        <>
          <EstilosNatal />
          <NeveNatal />
          <PresenteNatalModal aberto={presenteAberto} onFechar={() => setPresenteAberto(false)} />
        </>
      )}
      {/* ── Header idêntico ao Login ── */}
      <header className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 py-4 flex justify-between items-center shadow-md">
        <div className="flex items-center space-x-2">
          <span className="text-2xl font-bold tracking-tight">YOUX</span>
          <span className="text-xl font-light">GROUP</span>
        </div>
        {/* PERFIL DISCRETO NO HEADER */}
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-full border border-white/20">
          <UserCircle className="w-4 h-4 text-pink-300" />
          <span className="text-xs font-medium text-purple-100 uppercase tracking-wider">
            Perfil: {roleLabels[userRole] || userRole}
          </span>
        </div>
        <button
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/");
          }}
          className="flex items-center gap-2 px-4 py-2 hover:bg-red-500/20 rounded-lg text-sm font-bold text-white-400"
        >
          <LogOut className="w-4 h-4" />
          Sair
        </button>
      </header>

      {/* ── Hero de boas-vindas (no Natal, 1–25/dez, vira o hero festivo) ── */}
      {natal && <PiscaPisca />}
      {natal ? (
        <HeroNatal onAbrirPresente={() => setPresenteAberto(true)} />
      ) : (
      <div className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 pb-10 pt-6">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl font-bold leading-tight">
            Boas-vindas ao Painel Financeiro
          </h1>
          <p className="mt-2 text-purple-200 text-sm max-w-xl">
            Selecione um módulo abaixo para acessar as análises e ferramentas
            disponíveis para a sua equipe.
          </p>
        </div>
      </div>
      )}

      {/* ── Grid de cards ── */}
      <main className="flex-1 px-6 py-10 -mt-4">
        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[...availableModules, ...(isAdmin ? adminModules : [])].map((mod) => (
            <button
              key={mod.path}
              onClick={() => navigate(mod.path)}
              className="group text-left bg-white rounded-2xl shadow-sm border border-gray-100 p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col gap-4 focus:outline-none focus:ring-2 focus:ring-pink-500"
            >
              {/* Ícone + tag */}
              <div className="flex items-start justify-between">
                <div className="bg-gradient-to-br from-purple-900 to-pink-800 text-white p-3 rounded-xl shadow-md group-hover:scale-105 transition-transform duration-200">
                  {mod.icon}
                </div>
                <span
                  className={`text-xs font-semibold px-2.5 py-1 rounded-full ${tagColors[mod.tag]}`}
                >
                  {mod.tag}
                </span>
              </div>

              {/* Título + descrição */}
              <div>
                <h2 className="text-base font-semibold text-gray-800 mb-1 group-hover:text-pink-700 transition-colors">
                  {mod.title}
                </h2>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {mod.description}
                </p>
              </div>

              {/* Highlights */}
              <div className="flex flex-wrap gap-1.5 mt-auto pt-2 border-t border-gray-100">
                {mod.highlights.map((h) => (
                  <span
                    key={h}
                    className="text-xs text-gray-400 bg-gray-50 border border-gray-200 px-2 py-0.5 rounded-md"
                  >
                    {h}
                  </span>
                ))}
              </div>

              {/* CTA inline */}
              <span className="text-xs font-medium text-pink-700 group-hover:underline">
                Acessar módulo →
              </span>
            </button>
          ))}
        </div>
      </main>

      <footer className="text-center text-xs text-gray-400 py-6">
        {natal && <span className="block mb-1">🎄 Boas festas de toda a equipe do financeiro! 🎁</span>}
        © {new Date().getFullYear()} Youx Group · by financeiro
      </footer>
    </div>
  );
}
